import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_40000950_150903)">
        <path
          d="M11 2.75C17.6 2.75 19.25 4.4 19.25 11C19.25 17.6 17.6 19.25 11 19.25C4.4 19.25 2.75 17.6 2.75 11C2.75 4.4 4.4 2.75 11 2.75Z"
          fill="#FFEFF0"
          stroke="#E7212B"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7.33301V10.9997"
          stroke="#E7212B"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 14.667H11.0092"
          stroke="#E7212B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_40000950_150903">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
